export default __webpack_public_path__ + "static/media/linkedin.f249b382.png";